import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import { getCurrentDateFormatted } from "../../utils/utils";
import ExitButton from "../../components/common/ExitButton";
import ExitIcon from "../../assets/dashboardIcon/Exit.svg";
import DashboardBannerImage from "../../assets/images/dashboardBannerImage.svg";

export const DashboardBanner = ({
  handleEndButtonModal,
  logoutState,
  name,
  staffId,
}: {
  handleEndButtonModal?: () => void;
  logoutState?: boolean;
  name?: string;
  staffId?: any;
}) => {

   
  return (
    <Box>
      <Box
        sx={{
          width: "98%",
          height: "171px",
          margin: "10px auto",
          boxShadow: "0px 3px 8px 0px #0000001A",
          borderRadius: "10px",
          border: "1px solid #F2F2F4",
          backgroundColor: "#E4F4FF",
          position: "relative",
          overflow: "visible",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            height: "100%",
          }}
        >
          {/* Left Content */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "flex-start",
              marginLeft: "20px",
            }}
          >
            <Typography
              sx={{
                fontSize: "40px",
                fontWeight: "500",
                color: "black",
                marginBottom: "5px",
                textAlign: "left",
              }}
            >
              {staffId && name ? `Hi, ${name}` : "Hi,"}
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  fontSize: "24px",
                  fontWeight: "500",
                  color: "black",
                  marginBottom: "5px",
                  textAlign: "left",
                  marginRight: "30px",
                }}
              >
                {getCurrentDateFormatted()}
              </Typography>
              {logoutState && staffId && (
                <Box>
                  <ExitButton
                    title={"End Shift"}
                    src={ExitIcon}
                    height={"35px"}
                    handleOpenModal={handleEndButtonModal}
                  />
                </Box>
              )}
            </Box>
          </Box>

          {/* Image Section with Overlapping Effect */}
          <Box
            sx={{
              position: "absolute",
              bottom: "0",
              right: "20px",
              transform: "translateY(3%)",
            }}
          >
            <img
              style={{ height: "auto" }}
              src={DashboardBannerImage}
              alt="banner-img"
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
